<template>
  <component :is="getPseudoComponentForUid(componentData.frontendTemplateName)" :key="componentData.uid" />
</template>
<script setup>
import {getPseudoComponentForUid} from '@/modules/CmsComponentMapper.js';

defineProps({
  componentData: {
    type: Object,
    default: () => ({}),
  },
});
</script>
